import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/pagination";
// import required modules
import { Autoplay, HashNavigation, Navigation } from "swiper";
import { useSelector } from "react-redux";
import { useState } from "react";
import {
  MdOutlineKeyboardArrowDown,
  MdOutlineKeyboardArrowUp,
} from "react-icons/md";
import SubCat from "../components/SubCat";

const BannerSlider = () => {
  const { items: data } = useSelector((state) => state.banners);
  console.log(data);

  // const { items: subcategories } = useSelector((state) => state.subCategor);

  return (
    <div className="container mx-auto  mt-5 ">
      <div className="grid md:grid-cols-[25%_75%] grid-cols-1 gap-3">
        <div className="bg-white hidden md:block">
          <SubCat />
        </div>
        <div className="banner-slider-frame">
          <Swiper
            slidesPerView={"auto"}
            spaceBetween={30}
            autoplay={{
              delay: 3000,
              disableOnInteraction: false,
            }}
            speed={700}
            hashNavigation
            loop={true}
            modules={[Autoplay, Navigation, HashNavigation]}
            className="mySwiper h-full"
          >
            {data.map((image) => (
              <div key={image.id}>
                <SwiperSlide>
                  <div className="w-full h-full overflow-hidden">
                    <img
                      src={`${process.env.REACT_APP_URL}/public/uploads/slider/${image.slider}`}
                      alt={image.alt}
                      className={`h-full  w-full  object-cover`}
                    />
                  </div>
                </SwiperSlide>
              </div>
            ))}
          </Swiper>
        </div>
      </div>
    </div>
  );
};

export default BannerSlider;
